import React from "react";
import { useSelector } from "react-redux";
import "./reportsCss.css";

import {
  Typography,
  Table,
  TableRow,
  TableCell,
} from "@material-ui/core";

const style = {
  fontStyle: "bold",
  fontSize: "60px",
  color: "white",
};
const styleTitle = {
  backgroundColor: "#ef4123",
};

const TitleResultReport = ({ data, controlesArray, controles }) => {
  // data = {typeRow:1, reportType:tipoReporte , mod:Mod, cat:Cat, gen:Gen, ab:false}
  const eventSubEvents = useSelector((state) => state.events.eventSubEvents);


  console.log("titledata", data)
  var reportType = data.reportType;

  let filasAdicionales = 0;

  if (controles && controlesArray["modalidad_" + data.codMod] != undefined) {
    filasAdicionales = controlesArray["modalidad_" + data.codMod].tamano;
  }

  var GenTexto = data.gen == "F" ? "Femenil" : "Varonil";

  if (data.gen == "F") {
    GenTexto = "Femenil";
  } else if (data.gen == "V") {
    GenTexto = "Varonil";
  } else if (data.gen == "M") {
    GenTexto = "Mixto";
  }

  var element;
  // las filas de subclasificación usan la misma columna de "Lugar
  // Categoría" para mostrar su posición (ver RowResultReport.jsx/
  // TitleResultReportDefault.jsx), así que la cantidad de columnas es igual
  // en todos los tipos de reporte — no hace falta sumar nada acá.
  var filasFinal = 11 + filasAdicionales;
  if (reportType == 1) {
    //        <tr><td colSpan={filasFinal}>Resultados Generales Modalidad: {Mod}K </td></tr>
    //        <tr><td colSpan={filasFinal}>Resultados Generales Modalidad: {Mod}K </td></tr>
    element = (
      <TableRow style={styleTitle}>
        <TableCell align="center" style={style} colSpan={filasFinal}>
        
        
        <Typography variant={"h5"} component="h2" align="center">
        Resultados Generales {eventSubEvents["modalidad_" + data.codMod] && eventSubEvents["modalidad_" + data.codMod].descripcionModalidad} ({data.mod}K)
        </Typography>

        </TableCell>
      </TableRow>
    );
  } else if (reportType == 2) {
    // <tr><td colSpan={filasFinal}>Modalidad: {Mod}K - Rama {GenTexto} </td></tr>
    element = (
      <TableRow style={styleTitle}>
        <TableCell align="center" style={style} colSpan={filasFinal}>
         
        <Typography variant={"h5"} component="h2" align="center">
          {eventSubEvents["modalidad_" + data.codMod] && eventSubEvents["modalidad_" + data.codMod].descripcionModalidad} ({data.mod}K) - Rama {GenTexto}
        </Typography>
        </TableCell>
      </TableRow>
    );
  } else if (reportType == 3 || reportType == 4) {
    if (data.ab) {
      element = (
        <TableRow style={styleTitle}>
          <TableCell align="center" style={style} colSpan={filasFinal}>
            <Typography variant={"h5"} component="h2" align="center">
              {eventSubEvents["modalidad_" + data.codMod] && eventSubEvents["modalidad_" + data.codMod].descripcionModalidad} ({data.mod}K)- Rama {GenTexto} - Categoría Absolutos
            </Typography>
          </TableCell>
        </TableRow>
      );
    } else {
      element = (
        <TableRow style={styleTitle}>
          <TableCell align="center" style={style} colSpan={filasFinal}>
            <Typography variant={"h5"} component="h2" align="center">
              {eventSubEvents["modalidad_" + data.codMod] && eventSubEvents["modalidad_" + data.codMod].descripcionModalidad} ({data.mod}K) - Rama {GenTexto} - Categoría {data.cat}
            </Typography>
          </TableCell>
        </TableRow>
      );
    }
  } else if (reportType == 5) {
    // Subclasificación: el título nombra el valor de la variable (ej.
    // "Mérida") además de modalidad y rama — un mismo valor puede repetirse
    // en varias modalidades/ramas, cada combinación es su propio grupo.
    element = (
      <TableRow style={styleTitle}>
        <TableCell align="center" style={style} colSpan={filasFinal}>
          <Typography variant={"h5"} component="h2" align="center">
            {data.valorSubclasif} — {eventSubEvents["modalidad_" + data.codMod] && eventSubEvents["modalidad_" + data.codMod].descripcionModalidad} ({data.mod}K) - Rama {GenTexto}
          </Typography>
        </TableCell>
      </TableRow>
    );
  }

  return element;
};

export default TitleResultReport;
